import { useEffect, useRef } from "react";

// Lightweight canvas fireworks — bursts of sparks that rise and explode, no deps.
export default function Fireworks({ active, duration = 4500, onDone }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!active) return undefined;
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = window.innerWidth);
    let h = (canvas.height = window.innerHeight);
    const onResize = () => { w = canvas.width = window.innerWidth; h = canvas.height = window.innerHeight; };
    window.addEventListener("resize", onResize);
    const colors = ["#f5d061", "#ffffff", "#c084fc", "#34d399", "#f472b6", "#60a5fa", "#fb923c"];
    const rockets = [];
    const sparks = [];
    const start = performance.now();
    let raf;

    function launch() {
      rockets.push({ x: w * (0.2 + Math.random() * 0.6), y: h, vx: (Math.random() - 0.5) * 2, vy: -(9 + Math.random() * 5), color: colors[(Math.random() * colors.length) | 0], fuse: 40 + Math.random() * 25 });
    }
    function explode(r) {
      const n = 70 + (Math.random() * 50) | 0;
      for (let i = 0; i < n; i++) {
        const a = (Math.PI * 2 * i) / n + Math.random() * 0.2;
        const sp = 2 + Math.random() * 5;
        sparks.push({ x: r.x, y: r.y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 60 + Math.random() * 40, max: 100, color: Math.random() < 0.3 ? "#ffffff" : r.color, size: 1.5 + Math.random() * 2 });
      }
    }
    function frame(now) {
      const elapsed = now - start;
      ctx.fillStyle = "rgba(5, 3, 20, 0.22)";
      ctx.fillRect(0, 0, w, h);
      if (elapsed < duration - 1200 && Math.random() < 0.08) launch();
      for (let i = rockets.length - 1; i >= 0; i--) {
        const r = rockets[i];
        r.x += r.vx; r.y += r.vy; r.vy += 0.12; r.fuse -= 1;
        ctx.beginPath(); ctx.arc(r.x, r.y, 2.2, 0, Math.PI * 2); ctx.fillStyle = r.color; ctx.fill();
        if (r.fuse <= 0 || r.vy > -1) { explode(r); rockets.splice(i, 1); }
      }
      for (let i = sparks.length - 1; i >= 0; i--) {
        const s = sparks[i];
        s.x += s.vx; s.y += s.vy; s.vy += 0.06; s.vx *= 0.985; s.vy *= 0.985; s.life -= 1;
        ctx.globalAlpha = Math.max(0, s.life / s.max);
        ctx.beginPath(); ctx.arc(s.x, s.y, s.size, 0, Math.PI * 2); ctx.fillStyle = s.color; ctx.fill();
        ctx.globalAlpha = 1;
        if (s.life <= 0) sparks.splice(i, 1);
      }
      if (elapsed < duration || sparks.length || rockets.length) raf = requestAnimationFrame(frame);
      else onDone?.();
    }
    for (let i = 0; i < 3; i++) setTimeout(launch, i * 180);
    raf = requestAnimationFrame(frame);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", onResize); };
  }, [active, duration, onDone]);

  if (!active) return null;
  return (
    <div className="fixed inset-0 z-[100] pointer-events-none" data-testid="setup-fireworks">
      <canvas ref={ref} className="absolute inset-0" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center animate-[fadeInUp_.8s_ease-out]">
          <div className="text-5xl sm:text-7xl font-black tracking-tight text-white drop-shadow-[0_0_30px_rgba(245,208,97,.8)]">You're live!</div>
          <div className="mt-3 text-base sm:text-lg text-amber-200 font-semibold tracking-[0.3em] uppercase">Welcome to OreVital</div>
        </div>
      </div>
    </div>
  );
}
